import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateUserAccountResultModal} from './update-user-account.result.modal';
import {
    clearResult,
    selectUpdateUserAccountBulkUuid,
    selectUpdateUserAccountShown,
    selectUpdateUserAccountTask,
} from './update-user-account.slice';


export const UpdateUserAccountResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateUserAccountBulkUuid}
        actionTaskSelector={selectUpdateUserAccountTask}
        actionShownSelector={selectUpdateUserAccountShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UpdateUserAccountResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
